"use client";

import type { ComponentConfig } from "@puckeditor/core";

export interface PageHeroProps {
  heading?: string;
  intro?: string;
  sectionId?: string;
}

export const PageHeroBlock: ComponentConfig<PageHeroProps> = {
  label: "Page Hero",
  fields: {
    heading: { type: "text", label: "Page Heading" },
    intro: { type: "textarea", label: "Introduction" },
    sectionId: { type: "text", label: "Section ID" },
  },
  defaultProps: {
    heading: "Private-Label Manufacturing for Growing Brands",
    intro: "Build a clear formulation, testing, packaging, and production pathway with Shaaira Biocare's technical team.",
    sectionId: "manufacturing-introduction",
  },
  render: ({ heading, intro, sectionId }) => (
    <section className="page-hero" id={sectionId || undefined}>
      <div className="container">
        <h1>{heading}</h1>
        {intro && <p className="lead">{intro}</p>}
      </div>
    </section>
  ),
};
